import { FC, ReactNode } from 'react';

// styles
import styles from './TableEmptyState.module.scss';

interface TableEmptyStateProps {
	title?: string; // Custom title (e.g., "No Items", "Oops")
	message?: string; // Custom message (e.g., "No data available")
	status?: 'error' | 'empty'; // State type (error or empty)
	/** Optional product/functional icon only — no default stock illustration. */
	icon?: ReactNode;
	className?: string; // Custom class override
}

export const TableEmptyState: FC<TableEmptyStateProps> = ({
	title = 'Oops',
	message,
	status = 'empty',
	icon,
	className,
}) => {
	return (
		<div className={`${styles.noItemsContainer} ${className || ''}`}>
			<div className={styles.noItemsContainer__gradient} />
			{icon ? <div className={styles.noItemsIcon}>{icon}</div> : null}
			<div className={styles.noItemsTextContainer}>
				<span className={styles.noItemsTitle}>{title}</span>
				<span className={styles.noItemsText}>
					{message ||
						(status === 'error' ? 'Something went wrong.' : 'There are currently no items available.')}
				</span>
			</div>
		</div>
	);
};
